(() => {
  const videos = new Set();
  const pending = new WeakSet();

  function play(video) {
    if (!video.isConnected || !video.getAttribute('src') || !video.paused) return;
    video.play().catch(() => {});
  }

  function start(video) {
    if (!video.isConnected || video.dataset.loaded === 'true') return;
    const mobile = window.matchMedia('(max-width: 767px)').matches;
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.src = mobile ? video.dataset.mobileSrc : video.dataset.desktopSrc;
    video.dataset.loaded = 'true';
    play(video);
  }

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          start(entry.target);
        });
      }, { rootMargin: '350px 0px' })
    : null;

  function initialize(scope = document) {
    scope.querySelectorAll('video[data-jamr-continuous-video]').forEach(video => {
      if (pending.has(video)) return;
      pending.add(video);
      videos.add(video);
      video.addEventListener('playing', () => {
        video.closest('.custom-video-wrapper')?.classList.add('is-playing');
      });
      video.addEventListener('canplay', () => play(video));
      if (video.dataset.priority === 'hero') {
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if ('requestIdleCallback' in window) {
            requestIdleCallback(() => start(video), { timeout: 600 });
          } else {
            setTimeout(() => start(video), 100);
          }
        }));
      } else if (observer) {
        observer.observe(video);
      } else {
        start(video);
      }
    });
  }

  function resume() {
    videos.forEach(video => {
      if (video.isConnected) play(video);
      else videos.delete(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) resume();
  });
  document.addEventListener('pointerdown', resume, { passive: true });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
